import { Reducer, createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "../state";
import { SERVER_URL } from "../../utils/server";
import { Callback } from "../../index.d";
import { toggleSessionExpired } from "../utils/uiSlice";

export declare interface SuperCategorieState {
  [index: string]: any;
}

export interface SuperCategorie {
  [index: string]: any;
  libelle: string;
  referenceFichier?: string;
}

const initialState: SuperCategorieState = {};

export const superSuperCategorieSlice = createSlice({
  initialState,
  name: "super_categorie",
  reducers: {
    createSuperCategorie: (state, action) => {
      state[action.payload.id] = action.payload;
      return state;
    },
    listSuperCategorie: (state, action) => {
      for (const obj of action.payload) {
        state[obj.id] = obj;
      }
      return state;
    },
    removeSuperCategorie: (state, action) => {
      delete state[action.payload];
      return state;
    },
    updateSuperCategorie: (state, action) => {
      state[action.payload.id] = {
        ...state[action.payload.id],
        ...action.payload,
      };
      return state;
    },
  },
});

export const {
  createSuperCategorie,
  listSuperCategorie,
  removeSuperCategorie,
  updateSuperCategorie,
} = superSuperCategorieSlice.actions;

export const createAsyncSuperCategorie =
  (data: SuperCategorie, callback: Callback, onError: Callback) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;
      const result = await fetch(`${SERVER_URL}V2/super-categorie/admin-all`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      if (result.status === 201) {
        dispatch(listAsyncSuperCategorie());
        callback?.();
      } else {
        onError?.();
      }
    } catch (error) {
      console.log("create superCategorie error", error);
      onError?.();
    }
  };

export const updateAsyncSuperCategorie =
  (data: SuperCategorie, callback: Callback, onError: Callback) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;
      const result = await fetch(`${SERVER_URL}V2/super-categorie/admin-all/${data.id}`, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      if ([201,200].includes(result.status)) {
        dispatch(listAsyncSuperCategorie());
        callback?.();
      } else {
        onError?.();
      }
    } catch (error) {
      console.log("sign in error", error);
      onError?.();
    }
  };

export const listAsyncSuperCategorie =
  () => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(`${SERVER_URL}V2/super-categorie/admin-all`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const res = await result.json();

      if (res?.length) {
        dispatch(listSuperCategorie(res));
      }
    } catch (error) {
      console.log("list superCategorie error", error);
    }
  };

export default superSuperCategorieSlice.reducer as Reducer<SuperCategorieState>;
